import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})

export class BaseCookieService {
  public static keySelectedPatient = 'SelectedPatient';
  public static keySelectedPatientQueryCondition = 'SelectedPatientQueryCondition';
  constructor(private cookieService: CookieService) {
  }

  // 取得cookie
  getCookie(key: any) {
    const result = this.cookieService.get(key);
    console.log('cookie: ', key, ' = ', result);
    return result;
  }

  // 設定cookie
  setCookie(key: any, value: any) {
    this.cookieService.set(key, value);
  }
  // 刪除cookie
  deleteCookie(key){
    this.cookieService.delete(key);
  }
  // 設定cookie
  setCookie2(key: any, value: any) {
    this.cookieService.set(key, value, null, '/', null, true, 'None');
  }
  // 刪除cookie
  deleteCookie2(key){
    this.cookieService.delete(key,'/',null,true,'None');
  }
}
